import { render, staticRenderFns } from "./Survey.vue?vue&type=template&id=f5af90f8&scoped=true"
import script from "./Survey.vue?vue&type=script&lang=js"
export * from "./Survey.vue?vue&type=script&lang=js"
import style1 from "./Survey.vue?vue&type=style&index=1&id=f5af90f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5af90f8",
  null
  
)

export default component.exports